import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const PaxValidation = z.object({
  adults: z.number({ message: 'adults is required' }),
  children: z.number({ message: 'children is required' }).array(),
})

export class Pax extends Model {
  static create({ adults, children }: z.infer<typeof PaxValidation>) {
    PaxValidation.parse({ adults, children })
    return new Pax(adults, children)
  }

  static defaultPax() {
    return Pax.create({ adults: 2, children: [] })
  }

  constructor(
    private readonly _adults: number,
    private readonly _children: number[]
  ) {
    super()
  }

  get adults() { return this._adults } // prettier-ignore
  get children() { return this._children } // prettier-ignore

  toJSON() {
    return { adults: this.adults, children: this.children }
  }
}
